<ul *ngIf="!isEmpty">
  <li *ngFor="let item of list">
    <p>{{ item }}</p>
  </li>
</ul>

<p *ngIf="isEmpty">{{ emptyText }}</p>
